export function isTaskJob(job) {
    return String(job?.job_type || "").toLowerCase() === "task";
}

export function stringToDate(dateString) {
    const parts = dateString.split("-");
    return new Date(parts[0], parts[1] - 1, parts[2]);
}

export function sortSchedulerJobs(jobs = []) {
    return jobs.slice().sort((leftJob, rightJob) => {
        const leftHasB2BNew = leftJob.tags && leftJob.tags.includes("B2B_NEW");
        const rightHasB2BNew = rightJob.tags && rightJob.tags.includes("B2B_NEW");

        if (leftHasB2BNew && !rightHasB2BNew) {
            return -1;
        }
        if (!leftHasB2BNew && rightHasB2BNew) {
            return 1;
        }

        if (!leftJob.full_address) {
            return 1;
        }
        if (!rightJob.full_address) {
            return -1;
        }
        return leftJob.full_address.localeCompare(rightJob.full_address);
    });
}

export function mapItemsById(items = []) {
    return items.reduce((map, item) => {
        map[item.id] = item.name;
        return map;
    }, {});
}

export function buildStatusCounts(jobs = []) {
    return jobs.reduce((counts, job) => {
        counts[job.status] = counts[job.status] ? counts[job.status] + 1 : 1;
        return counts;
    }, {});
}

export function buildFieldCounts(jobs = [], fieldName) {
    return jobs.reduce((counts, job) => {
        if (job.status === "Cancelled") {
            return counts;
        }

        counts[job[fieldName]] = counts[job[fieldName]] ? counts[job[fieldName]] + 1 : 1;
        return counts;
    }, {});
}

export function buildWorkerCounts(jobs = []) {
    return buildFieldCounts(jobs, "cos_job_worker");
}

export function buildSummaryCountMap(summaryCounts = []) {
    return summaryCounts.reduce((map, count) => {
        map[count.cos_job_id] = count;
        return map;
    }, {});
}

export function enrichJobsWithSummaryCounts(jobs = [], summaryCountMap = {}) {
    return jobs.map((job) => ({
        ...job,
        notes_count: summaryCountMap[job.cos_job_id]?.notes_count ?? 0,
        images_count: summaryCountMap[job.cos_job_id]?.images_count ?? 0,
        req_fix_count: summaryCountMap[job.cos_job_id]?.req_fix_count ?? 0,
        req_deep_clean_count: summaryCountMap[job.cos_job_id]?.req_deep_clean_count ?? 0,
        req_key_count: summaryCountMap[job.cos_job_id]?.req_key_count ?? 0,
    }));
}

export function jobMatchesSearch(job, searchText, fieldWorkerMap, fieldSupervisorMap) {
    if (!searchText) {
        return true;
    }

    const normalizedSearch = searchText.toLowerCase();
    const values = [
        job.full_address,
        job.agent_name,
        job.cos_customer_name,
        job.phone,
        job.email,
        job.cos_job_id,
        fieldWorkerMap[job.cos_job_worker],
        fieldSupervisorMap[job.cos_job_supervisor],
    ];

    return values.some((value) => value && value.toLowerCase().includes(normalizedSearch));
}

export function buildStatusCountsWithTask(jobs = []) {
    const counts = buildStatusCounts(jobs);
    counts.Task = jobs.filter(isTaskJob).length;
    return counts;
}
